<template>
  <v-navigation-drawer
    fixed
    app
    v-model="drawer"
    class="white--text"
    id="core-navigation-drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    :src="require('../../assets/img/sidebar2.jpeg')"
    mobile-break-point="960"
    width="260"
    v-bind="$attrs"
  >
    <template v-slot:img="props">
      <v-img :gradient="`to bottom, ${barColor}`" v-bind="props" />
    </template>

    <v-divider class="mb-1" />
    <v-list dense nav>
      <v-list-item>
        <v-list-item-avatar class="align-self-center" color="white" contain>
          <v-img :src="require('../../assets/img/mpc.png')" max-height="30" />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title class="display-2" v-text="profile.title" />
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider class="mb-2" />
    <v-list dense>
      <template v-for="item in items">
        <v-list-group
          v-if="item.childs"
          v-model="item.expanded"
          :key="item.title"
          :prepend-icon="item.icon"
          :append-icon="item.expanded ? 'mdi-chevron-down' : 'mdi-chevron-down'"
        >
          <v-list-item slot="activator">
            <v-list-item-content>
              <v-list-item-title class="white--text">
                {{ $t(item.title) }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-for="(child, i) in item.childs" :key="i" :to="child.to">
            <v-list-item-action v-if="child.icon">
              <v-icon class="white--text pl-3">{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="white--text slim"> {{ $t(child.title) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-item v-else :to="item.to" :key="item.title">
          <v-list-item-action>
            <v-icon class="white--text">{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="white--text"> {{ $t(item.title) }} </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapState } from "vuex";

export default {
  name: "DashboardCoreDrawer",

  props: {
    expandOnHover: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    items: [
      {
        icon: "mdi-view-dashboard",
        title: "menu_sales_title",
        expanded: false,
        childs: [
          {
            title: "menu_manage_order",
            icon: "mdi-cart-outline",
            to: "/sales_order",
          },
          {
            title: "sales_report_by_day",
            icon: "mdi-file-chart-outline",
            to: "/report_order_by_dates",
          },
          {
            title: "sales_report_by_brands",
            icon: "mdi-file-chart-outline",
            to: "/report_order_by_customer_brands",
          },
        ],
      },
    ],
    user: {
      username: "",
      fullname: "",
      email: "",
      permissions: [],
    },
  }),

  computed: {
    ...mapState(["barColor", "barImage"]),
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.$store.commit("SET_DRAWER", val);
      },
    },
    computedItems() {
      return this.items.map(this.mapItem);
    },
    profile() {
      return {
        avatar: true,
        title: this.$t("avatar"),
      };
    },
  },
  mounted() {
    this.loadPermissions();
  },
  methods: {
    mapItem(item) {
      return {
        ...item,
        children: item.children ? item.children.map(this.mapItem) : undefined,
        title: this.$t(item.title),
      };
    },

    loadPermissions() {
      this.user.fullname = localStorage.getItem("fullname");
      this.user.email = localStorage.getItem("email");
      this.user.permissions = JSON.parse(localStorage.getItem("permissions"));
      for (let j = 0; j < this.items.length; j++) {
        for (let i = 0; i < this.items[j].childs.length; i++) {
          let objIndex = this.user.permissions.findIndex((obj) => obj.screen === this.items[j].childs[i].to);
          if (objIndex === -1) {
            this.items[j].childs.splice(i, 1);
            i = i - 1;
          }
        }
        if (this.items[j].childs.length === 0) {
          this.items.splice(j, 1);
          j = j - 1;
        }
      }
    },
  },
};
</script>

<style>
#app {
  font-family: Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#drawer i.v-icon.material-icons {
  color: white !important;
}

.slim {
  font-weight: 100;
}

#drawer a.v-list__tile--link:hover {
  border-left: solid white 4px;
}

#drawer a.v-list__tile--active {
  border-left: solid white 4px;
  background-color: rgba(0, 0, 0, 0.12);
}
</style>
